import { useTranslation } from 'react-i18next';

import { formatUsd } from '@/utils/money';

import { TOTAL_DECIMALS, UNIT_DECIMALS } from './useUsd.constants';
import type { UsdFormatter } from './useUsd.types';

/** The console's only way to print money, bound to the UI language. */
export const useUsd = (): UsdFormatter => {
	const { i18n } = useTranslation();
	const locale = i18n.language;

	return {
		total: (value: number) => formatUsd(value, locale, TOTAL_DECIMALS),
		unit: (value: number) => formatUsd(value, locale, UNIT_DECIMALS),
	};
};
